var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.592,
    height: 36.215,
    viewBox: "0 0 37.592 36.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.023,
    y1: 0.505,
    x2: 1.074,
    y2: 0.498,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64c7ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185d4a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Combined_Shape_Copy_4",
    x: 0,
    y: 0,
    width: 37.592,
    height: 36.215,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Combined_Shape_Copy_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape_Copy_4-2",
    "data-name": "Combined Shape Copy 4",
    d: "M7.682,16.115.32,8.976a1.162,1.162,0,0,1,0-1.6L7.681.236c.571-.553,1.427-.072,1.427.8V15.314a.962.962,0,0,1-.878,1.037A.781.781,0,0,1,7.682,16.115Zm15.469-2.682V3.082h4.37v10.35Zm-6.116,0V3.082H21.4v10.35Zm-6.116,0V3.082h4.37v10.35Z",
    transform: "translate(34.59 15.53) rotate(140)",
    opacity: 0.9,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpYellow);
export default __webpack_public_path__ + "static/media/arrow_up_yellow.fe39c833f2f995f6352c0ab386965385.svg";
export { ForwardRef as ReactComponent };